var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',{scopedSlots:_vm._u([{key:"side",fn:function(){return [_c('ButtonIcon',{on:{"click":function($event){return _vm.addCampaign()}}},[_vm._v(_vm._s(_vm.$t('addCampaign')))])]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.$t('campaignsList'))+" ")]),_c('Filters',{ref:"Filters"}),_c('Results',{ref:"Results"}),_c('ModalAddCampaign')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }